import React from 'react';

import { direction, DIRECTION_STYLES, IconProps } from './types';

import cn from '~/utils/cn';

const DEFAULT_ICON_PROPS: IconProps = {
  size: 16,
  disabled: false,
  className: 'text-slate-900',
  direction: 'up',
};

interface Props extends React.SVGProps<SVGSVGElement>, IconProps {
  disableStrokeColor?: boolean;
  direction?: direction;
}

const SvgIcon: React.FC<Props> = ({
  disabled,
  children,
  disableStrokeColor = false,
  size = DEFAULT_ICON_PROPS.size,
  className = DEFAULT_ICON_PROPS.className,
  direction = DEFAULT_ICON_PROPS.direction,
  ...rest
}) => {
  const svgProps = {
    opacity: disabled ? 0.26 : 1,
    width: size,
    height: size,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...svgProps}
      className={cn(className, DIRECTION_STYLES[direction || 'up'])}
      {...rest}
      stroke={disableStrokeColor ? 'transparent' : 'currentColor'}
    >
      {children}
    </svg>
  );
};

export default SvgIcon;
